<!-- Sidebar -->
<nav id="sidebar" [ngClass]="{'active': sidebarStatus === true}">
  <div class="sidebar-header animated bounce fadeIn">
    <div class="row">
      <div class="col-4 center line-height-100 pr0">
        <img *ngIf="!imageCommunity" [src]="logoCommunity" class="community-image br-circle" alt="comunidad">
        <img *ngIf="imageCommunity" [src]="imageCommunity" class="community-image br-circle" alt="comunidad">
      </div>
      <div class="col-8 text-left pt15">
        <label class="font-normal community txt-item">{{communityInSession}}</label>
        <label class="font-normal community-secondary">{{'GENERAL.IDENTIFIER' | translate }} {{codeCommunityInSession | rut}}</label>
        <label class="font-normal community-secondary" *ngIf="emailUser">
          {{emailUser}}</label>
      </div>
    </div>
  </div>

  <!-- Sidebar Links -->
  <ul *ngIf="menu" class="components mt10 animated bounce fadeIn">
    <li *ngFor="let module of menu; let i=index;">
      <a routerLinkActive="active" *ngIf="module.link && validPermission(module.permission)" [routerLink]="module.link">
        <label *ngIf="module.link === urlActive">
          <i class="fal {{module.icon}} mr10 svg-width txt-secondary"></i>
        </label>
        <label *ngIf="module.link !== urlActive">
          <i class="fal {{module.icon}} mr10 svg-width"></i>
        </label>
        <span class="txt-item">
          {{ module.name | translate}}
        </span>
      </a>
      <a routerLinkActive="active" *ngIf="!module.link && validPermission(module.permission)" data-toggle="collapse" id="element_{{i}}"
        [attr.data-target]="'#' + module.entity" aria-expanded="false" href="#">
        <label *ngIf="validateRoute(module.sub) === true">
          <i class="fal {{module.icon}} mr10 svg-width txt-secondary"></i>
        </label>
        <label *ngIf="validateRoute(module.sub) === false">
          <i class="fal {{module.icon}} mr10 svg-width"></i>
        </label>
        <span class="txt-item">
          {{ module.name | translate}}
        </span>
      </a>
      <ul *ngIf="!module.link" class="collapse animated bounce fadeIn" id="{{module.entity}}">
        <li *ngFor="let item of module.sub; let i=index">
          <div *ngIf="item.link && validPermission(item.permission)" [ngClass]="{'circle': urlActive !== item.link,'circle-active': urlActive === item.link}"
            class="ml25"></div>
          <a routerLinkActive="active" *ngIf="item.link && validPermission(item.permission)" class="pl40" [routerLink]="item.link">
            {{ item.name | translate}}
          </a>
          <a routerLinkActive="active" *ngIf="!item.link && validPermission(item.permission)" class="pl40" data-toggle="collapse"
            id="element2_{{i}}" [attr.data-target]="'#' + item.entity" aria-expanded="false" href="#">
            {{item.name | translate}}
          </a>
          <ul *ngIf="!item.link" class="collapse animated bounce fadeIn" id="{{item.entity}}">
            <li *ngFor="let subMenu of item.sub; let i=index">
              <div *ngIf="subMenu.link && validPermission(subMenu.permission)" [ngClass]="{'circle': urlActive !== subMenu.link,'circle-active': urlActive === subMenu.link}"
                class="ml35"></div>
              <a *ngIf="subMenu.link && validPermission(subMenu.permission)" class="pl50" routerLinkActive="active"
                [routerLink]="subMenu.link">
                {{subMenu.name| translate}}
              </a>
              <a *ngIf="!subMenu.link && validPermission(subMenu.permission)" class="pl50" data-toggle="collapse" id="subLevel3_{{i}}"
                [attr.data-target]="'#' + subMenu.entity" aria-expanded="false" href="#">
                {{ subMenu.name | translate }}
              </a>
              <ul *ngIf="!subMenu.link && validPermission(subMenu.permission)" class="collapse" id="{{subMenu.entity}}">
                <li *ngFor="let subMenu2 of subMenu.sub; let i=index">
                  <div [ngClass]="{'circle': urlActive !== subMenu2.link,'circle-active': urlActive === subMenu2.link}"
                    class="ml45"></div>
                  <a class="pl60" routerLinkActive="active" id="subLevel4_{{i}}" [routerLink]="subMenu2.link">
                    {{subMenu2.name | translate}}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <div class="sidebar-footer animated bounce fadeIn">
    <!--<div *ngIf="help && this.currentUser.realm === 'kastor'">
      <div class="info-help animated bounce fadeIn">
        <div class="pb10" id="help">
          <label class="float-right" for="fa-times" (click)="help = !help">
            <i class="fal fa-times"></i>
          </label>
          <label class="txt-item">{{'GENERAL.INFO_HELP_KASTOR.TITLE' | translate}}</label>
          <label class="font-normal text-help">
            <i class="fal fa-phone txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KASTOR.PHONE_1' | translate}}">{{'GENERAL.INFO_HELP_KASTOR.PHONE_1'
              | translate}}</a>
            &nbsp;&nbsp;&nbsp;&nbsp;<i class="fal fa-phone txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KASTOR.PHONE_2'
            | translate}}">{{'GENERAL.INFO_HELP_KASTOR.PHONE_2'
                | translate}}</a>
          </label>
          <label class="font-normal text-help">
            <i class="fal fa-mobile-alt txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KASTOR.PHONE_3'
            | translate}}">{{'GENERAL.INFO_HELP_KASTOR.PHONE_3'
            | translate}}</a>
            &nbsp;&nbsp;&nbsp;&nbsp;<i class="fal fa-mobile-alt txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KASTOR.PHONE_4'
            | translate}}">{{'GENERAL.INFO_HELP_KASTOR.PHONE_4'
            | translate}}</a>
          </label>
          <label class="font-normal text-help"><i class="fal fa-envelope txt-secondary"></i> <a href="mailto:{{'GENERAL.INFO_HELP_KASTOR.MAIL'
            | translate}}">{{'GENERAL.INFO_HELP_KASTOR.MAIL'
              | translate}}</a></label>
          <label class="font-normal text-help"><i class="fal fa-clock txt-secondary"></i> {{'GENERAL.INFO_HELP_KASTOR.SCHEDULE'
            | translate}}</label>
        </div>
      </div>
      <div class="triangle-base animated bounce fadeIn">

      </div>
    </div>

    <div *ngIf="help && this.currentUser.realm === 'kiungo'">
      <div class="info-help animated bounce fadeIn">
        <div class="pb10" id="help">
          <label class="float-right" for="fa-times" (click)="help = !help">
            <i class="fal fa-times"></i>
          </label>
          <label class="txt-item">{{'GENERAL.INFO_HELP_KIUNGO.TITLE' | translate}}</label>
          <label class="font-normal text-help">
            <i class="fal fa-phone txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KIUNGO.PHONE_1' | translate}}">{{'GENERAL.INFO_HELP_KIUNGO.PHONE_1'
              | translate}}</a>
            &nbsp;&nbsp;&nbsp;&nbsp;<i class="fal fa-phone txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KIUNGO.PHONE_2'
            | translate}}">{{'GENERAL.INFO_HELP_KIUNGO.PHONE_2'
                | translate}}</a>
          </label>
          <label class="font-normal text-help">
            <i class="fal fa-mobile-alt txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KIUNGO.PHONE_3'
            | translate}}">{{'GENERAL.INFO_HELP_KIUNGO.PHONE_3'
            | translate}}</a>
            &nbsp;&nbsp;&nbsp;&nbsp;<i class="fal fa-mobile-alt txt-secondary"></i> <a href="tel:{{'GENERAL.INFO_HELP_KIUNGO.PHONE_4'
            | translate}}">{{'GENERAL.INFO_HELP_KIUNGO.PHONE_4'
            | translate}}</a>
          </label>
          <label class="font-normal text-help"><i class="fal fa-envelope txt-secondary"></i> <a href="mailto:{{'GENERAL.INFO_HELP_KIUNGO.MAIL'
            | translate}}">{{'GENERAL.INFO_HELP_KIUNGO.MAIL'
              | translate}}</a></label>
          <label class="font-normal text-help"><i class="fal fa-clock txt-secondary"></i> {{'GENERAL.INFO_HELP_KIUNGO.SCHEDULE'
            | translate}}</label>
        </div>
      </div>
      <div class="triangle-base animated bounce fadeIn">

      </div>
    </div>-->

    <button (click)="goToHelpCenter()" class="btn btn-fantasma btn-block txt-item help-button">{{'GENERAL.HELP_CENTER' | translate}}<i class="far fa-comments-question ml5 help-icon"></i></button>
    <h5>{{'GENERAL.COMMUNITY_INFO' | translate}}</h5>
    <h6>{{'GENERAL.ADDRESS' | translate}}: {{addressCommunity}}</h6>
  </div>
</nav>



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/sidebar.component.html